import { Seo, breadcrumbSchema, faqSchema } from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { TrustStrip } from "../components/TrustStrip";
import { FaqAccordion } from "../components/FaqAccordion";
import { CtaBlock } from "../components/CtaBlock";
import { Reveal, Eyebrow } from "../components/Reveal";
import { BIZ } from "../data/site";

const FAQS = [
  { q: "Do you provide free collision repair estimates in Carrollton?", a: "Yes, Westway Collision Center provides comprehensive free estimates. Submit photos through our online estimate form or visit our facility at 1420 Westway Cir in Carrollton for an in-person diagnostic evaluation — zero obligation either way." },
  { q: "Can I choose my own auto body shop for an insurance claim in Texas?", a: "Absolutely. Texas state law guarantees your legal right to choose any certified repair facility for your vehicle restoration. Westway Collision Center works directly with all major insurance providers, managing supplements and documentation directly so you do not have to." },
  { q: "What does I-CAR Gold Class certification mean for my car repair?", a: "I-CAR Gold Class is the highest standard tier recognized in the collision industry. It ensures our certified technicians undergo continuous, rigorous training to properly navigate advanced vehicle materials, computerized structural alignment, and complex electronic ADAS safety systems." },
  { q: "Do you handle the insurance claim process directly?", a: "Yes. We manage the entire claims process with all major carriers — estimate submission, supplement approvals, adjuster communications, and rental coordination. Your claim number is all we need to take over." },
  { q: "Do you offer free towing?", a: "Yes — free flatbed towing to our Carrollton facility is available when we complete your repair [PLACEHOLDER: tow radius/conditions]. Call (214) 888-2886 to dispatch." },
  { q: "Can I get a loaner or rental car during my repair?", a: "Yes. We coordinate loaner and insurance-approved rental vehicles timed to your drop-off, working directly with Enterprise and other major providers so you stay mobile." },
  { q: "What does your lifetime warranty cover?", a: "Our written lifetime warranty covers workmanship and paint finishes for as long as you own the vehicle. It is a signed document, not a verbal promise — if our work ever falls short of factory standard, we make it right." },
  { q: "Do you repair luxury and exotic vehicles?", a: "Yes — Ferrari, Bentley, Lamborghini, Aston Martin, Porsche, McLaren, Mercedes-AMG, and BMW M vehicles are our core clientele, repaired with OEM procedures, aluminum and surface capability, and indoor storage." },
  { q: "How long will my repair take?", a: "Timelines depend on damage severity and parts availability [PLACEHOLDER: typical turnaround ranges by service]. Your written estimate includes a realistic delivery date, and we update you at every stage." },
  { q: "Do you offer financing for repairs?", a: "Yes — financing is available for repairs, deductibles, and upgrades [PLACEHOLDER: financing provider and terms]. Apply in-shop or by phone with a fast decision." },
  { q: "What payment methods do you accept?", a: "[PLACEHOLDER: payment methods accepted.] Insurance-covered repairs are settled directly with your carrier; you pay only your deductible at pickup." },
  { q: "What are your hours?", a: `We are open Monday through Friday 7:30 AM to 6:00 PM and Saturday 8:00 AM to 5:00 PM, closed Sundays. Reach us any time at ${BIZ.phoneDisplay} or through the online estimate form.` },
];

export default function FaqPage() {
  return (
    <div data-testid="faq-page">
      <Seo
        title="Collision Repair FAQs — Carrollton, TX | Westway Collision"
        description="Answers on estimates, insurance claims, towing, rentals, warranties & repair timelines at Westway Collision Center, Carrollton, TX. (214) 888-2886."
        path="/faq"
        schemas={[
          faqSchema(FAQS),
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
        ]}
      />

      <section className="relative pt-32 lg:pt-40 pb-14 overflow-hidden">
        <div className="absolute inset-0 surface-weave opacity-50" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]} />
          <Reveal className="text-center flex flex-col items-center">
            <Eyebrow>Master FAQ</Eyebrow>
            <h1 className="mt-5 font-display text-3xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.08] text-balance">
              Collision Repair Questions, Answered — Carrollton, TX
            </h1>
            <p className="mt-5 max-w-2xl text-sm sm:text-base text-slate-400 leading-relaxed">
              Every answer below comes straight from how we actually run the shop. For anything not
              covered, call {BIZ.phoneDisplay} — a person answers.
            </p>
          </Reveal>
        </div>
      </section>

      <TrustStrip />

      <section className="py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <FaqAccordion faqs={FAQS} idPrefix="master-faq" />
        </div>
      </section>

      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <CtaBlock heading="Still Have a Question?" sub="Call us or send a free estimate request — a master technician will give you a straight answer." />
        </div>
      </section>
    </div>
  );
}
